import { render, staticRenderFns } from "./SettingKeyValues.vue?vue&type=template&id=2008c07b&"
import script from "./SettingKeyValues.vue?vue&type=script&lang=js&"
export * from "./SettingKeyValues.vue?vue&type=script&lang=js&"
import style0 from "./SettingKeyValues.vue?vue&type=style&index=0&id=2008c07b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports